import { Box } from "@chakra-ui/react";

import OrganizationTicketsPerServiceTable from "../../../organization/tables/daily/OrganizationTicketsPerService";
import EnterpriseReportSummary from "../../../reports/EnterpriseReportSummary";
import { buildTicketVolumeInsights } from "../../../../store/reportEnterpriseInsights";

const BranchTicketsPerService = ({
  branchId = null,
  reportIndex,
  branchIndex,
  data,
  numServices = 0,
  branchName = null,
  renderConfig,
}) => {
  const insights = buildTicketVolumeInsights(data, { scopeLabel: "Service" });

  return (
    <Box>
      <EnterpriseReportSummary
        title="Daily Service Ticket Demand Summary"
        kpis={insights.kpis}
        tables={insights.tables}
        notes={insights.notes}
      />
      <OrganizationTicketsPerServiceTable
        branchId={branchId}
        data={data}
        numServices={numServices}
        branchName={branchName}
        reportIndex={reportIndex}
        branchIndex={branchIndex}
        renderConfig={renderConfig}
      />
    </Box>
  );
};

export default BranchTicketsPerService;
